var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThreeLines(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 31,
    viewBox: "0 0 33 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3985 28.4592C6.40509 27.8568 6.93639 27.3733 7.5852 27.3795C12.9514 27.4301 18.2965 27.7157 23.6215 28.0003C24.2993 28.0365 24.9767 28.0727 25.6538 28.1084C26.3016 28.1426 26.7969 28.6579 26.7601 29.2594C26.7234 29.8609 26.1684 30.3209 25.5206 30.2867C24.8418 30.2509 24.1638 30.2147 23.4865 30.1785C18.155 29.8937 12.8681 29.6112 7.56133 29.5611C6.91252 29.555 6.39191 29.0617 6.3985 28.4592Z",
    fill: "#AFD34F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.968 14.3228C32.1213 14.9607 31.7436 15.6059 31.1244 15.7639C29.9558 16.0619 28.788 16.3583 27.6211 16.6545C20.8016 18.3855 14.0138 20.1085 7.29488 22.0991C6.68181 22.2807 6.0419 21.9159 5.8656 21.2843C5.6893 20.6527 6.04337 19.9934 6.65645 19.8118C13.4217 17.8074 20.258 16.0722 27.0758 14.3417C28.241 14.046 29.4056 13.7504 30.5692 13.4536C31.1885 13.2957 31.8147 13.6848 31.968 14.3228Z",
    fill: "#AFD34F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7852 1.0384C18.1769 1.52542 18.1022 2.23982 17.6183 2.63407L1.83658 15.4922C1.35269 15.8864 0.642864 15.8112 0.251142 15.3242C-0.14058 14.8372 -0.0658612 14.1228 0.41803 13.7286L16.1998 0.870438C16.6837 0.476189 17.3935 0.55139 17.7852 1.0384Z",
    fill: "#AFD34F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeLines);
export default __webpack_public_path__ + "static/media/three-lines.6db166697260d8c22d1b4de0e6ef0cdb.svg";
export { ForwardRef as ReactComponent };